import { motion } from "framer-motion";
import { BadgeCheck, Globe2, MapPin, ShieldCheck } from "lucide-react";

const standards = [
  { label: "Business Identity", score: 98 },
  { label: "Factory Verification", score: 96 },
  { label: "Export Readiness", score: 94 },
];

export const HeroDashboard = () => {
  return (
    <div
      data-testid="hero-dashboard"
      className="relative w-full rounded-3xl border border-slate-200/80 bg-white shadow-[0_24px_48px_rgba(15,23,42,0.08)] overflow-hidden"
    >
      <div className="relative h-52 sm:h-56">
        <img
          src="https://images.pexels.com/photos/9305407/pexels-photo-9305407.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Verified textile factory"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent" />
        <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur text-emerald-700 text-xs font-semibold border border-emerald-100 shadow-sm">
          <BadgeCheck className="w-3.5 h-3.5 text-emerald-500" />
          Verified
        </span>
        <div className="absolute bottom-4 left-5 right-5">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-white/95 text-slate-900 text-sm font-semibold shrink-0">
              AT
            </span>
            <div className="min-w-0 text-white">
              <p className="text-base font-semibold font-heading tracking-tight truncate">Anatolia Textile Group</p>
              <p className="flex items-center gap-1.5 text-xs text-white/80 mt-0.5">
                <MapPin className="w-3 h-3 shrink-0" />
                Istanbul, Türkiye
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-6">
        <div className="flex items-center justify-between gap-4 pb-5 border-b border-slate-100">
          <div>
            <p className="text-[11px] font-medium text-slate-400 uppercase tracking-wide">Verification Score</p>
            <p className="mt-1 text-3xl font-bold font-heading tracking-tight text-slate-900">98<span className="text-lg text-slate-400 font-medium">/100</span></p>
          </div>
          <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-emerald-50 border border-emerald-100">
            <ShieldCheck className="w-4 h-4 text-emerald-600" />
            <span className="text-xs font-semibold text-emerald-700">Export Ready</span>
          </div>
        </div>

        <div className="mt-5 space-y-3">
          {standards.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, x: 12 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.35 + i * 0.1, duration: 0.45 }}
            >
              <div className="flex items-center justify-between text-xs mb-1.5">
                <span className="text-slate-500 font-medium">{s.label}</span>
                <span className="font-mono font-semibold text-slate-800">{s.score}%</span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
                <motion.div
                  className="h-full rounded-full bg-gradient-to-r from-blue-500 to-emerald-500"
                  initial={{ width: 0 }}
                  animate={{ width: `${s.score}%` }}
                  transition={{ delay: 0.5 + i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                />
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-5 pt-5 border-t border-slate-100 flex flex-wrap gap-2">
          {["EU", "USA", "UK"].map((m) => (
            <span
              key={m}
              className="inline-flex items-center gap-1 text-[11px] font-medium px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-100"
            >
              <Globe2 className="w-3 h-3" />
              {m}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroDashboard;
